<mat-form-field [appearance]='configuration?.appearance ?? "legacy"'>
  <mat-label>Evento</mat-label>
  <mat-select [formControl]='control' [multiple]='configuration?.multiple'>
    <mat-option *ngFor='let value of values' [value]='value.Oid'>{{ value.StartDate | date }} - {{ value.ProductDescription }}</mat-option>
    <mat-option *ngIf='configuration?.nullValueEnabled' [value]='null'>Vedi tutto</mat-option>
  </mat-select>
</mat-form-field>
